// extracted by mini-css-extract-plugin
export default {"wrapper":"nU-z","availablePromoMessagesLabel":"oU-z","promoMessageList":"pU-z","promoMessage":"qU-z","appliedPromoMessage":"rU-z","promoMessageAmount":"sU-z"};